const InitialValues = {
  worker_type_name: '',
  satu_hari_kerja: '',
  hari_kerja_perminggu: '',
  harian: '',
  mingguan: '',
  bulanan: '',
  tahunan: '',
  total: '',
};

export default InitialValues;
